export default __webpack_public_path__ + "static/media/NPOQR.2db069bd.png";